/**
 * 模糊文本匹配请求参数
 */
export interface FuzzyTextMatchRequest {
    /**
     * 待匹配的文本
     */
    cell: string;
    /**
     * 文本语言
     */
    cell_lang: 'CN' | 'EN' | 'JP' | 'TW';
    /**
     * 原文文本
     */
    origin_text: string;
}

/**
 * 模糊文本匹配响应数据
 */
export interface FuzzyTextMatchResponseData {
    /**
     * API类型标识
     */
    api_type: 'find_cell_from_ori_text';
    /**
     * 匹配到的文本列表
     */
    cell_lst: string[];
}

/**
 * 模糊文本匹配API接口
 * @description 用于在原文中模糊匹配指定文本的API接口定义
 */
export const FuzzyTextMatchApi = Symbol.for('FuzzyTextMatchApi');

/**
 * 模糊文本匹配API接口
 */
export interface FuzzyTextMatchApi {
    /**
     * 在原文中模糊匹配指定文本
     * @param data 模糊文本匹配请求参数
     * @returns 匹配结果
     * @description 当文本在原文中无法精确匹配时，通过此接口找到最相似的文本
     */
    findTextInOrigin(data: FuzzyTextMatchRequest): Promise<FuzzyTextMatchResponseData>;
}
